module.exports = __webpack_public_path__ + "media/5.509f12fd.mp3";